import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';
import { AppLayout, NoNavLayout } from 'src/layouts/dashboard';

import RequireAuth from './components/RequireAuth';

export const LoginPage = lazy(() => import('../pages/login'));
export const Page404 = lazy(() => import('../pages/page-not-found'));
export const TherapyPage = lazy(() => import('../pages/therapy'));
export const InstructionsPage = lazy(() => import('../pages/instructions'));
export const AppPage = lazy(() => import('../pages/app'));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      element: (
        <NoNavLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </NoNavLayout>
      ),
      children: [
        { path: ':lang?/login/', element: <LoginPage /> },
        { path: 'instructions/:type?', element: <InstructionsPage /> },
        { path: 'therapy', element: <TherapyPage /> },
      ],
    },
    {
      element: (
        <AppLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </AppLayout>
      ),
      children: [
        { index: true, element: <RequireAuth element={null} /> },
        { path: 'app/:postback?', element: <RequireAuth element={<AppPage id="app" />} /> },
      ],
    },
    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
